import { createSlice } from "@reduxjs/toolkit"

import { createEntityAdapter } from "@reduxjs/toolkit"
import { loadProcessValidatedObject } from "../validationProcess/validatedObjectApi"
import { loadValidationProcessStageOverview } from "../validationProcess/validationProcessApi"
import { loadProjectProcess, ProjectProcess } from "./ProjectProcessApiClient"

export const projectProcessAdapter = createEntityAdapter<ProjectProcess>({
    selectId: (process) => process.id,
})

const initialState = projectProcessAdapter.getInitialState()

export const projectProcessSlice = createSlice({
    name: "projectProcess",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(loadProjectProcess.fulfilled, (state, action) => {
            projectProcessAdapter.setOne(state, action.payload)
        })
        builder.addCase(loadProcessValidatedObject.fulfilled, (state, action) => {
            const proc = state.entities[action.meta.arg]
            if (proc) {
                projectProcessAdapter.updateOne(state, {
                    id: proc.id,
                    changes: {
                        validatedObject: action.payload
                    }
                })
            }
        })
        // TODO: workaround here - because loadProjectProcess doesnt contain URS stage
        builder.addCase(loadValidationProcessStageOverview.fulfilled, (state, action) => {
            const processId = action.meta.arg
            const items = action.payload
            const process = state.entities[processId]
            if (process) {
                const ursStage = items.find(x => x.stage === 'URS')
                if (ursStage && ursStage.documents.length > 0) {
                    for (let i = 0; i < ursStage.documents.length; i++) {
                        const doc = ursStage.documents[i];
                        process.projectProcessStages.push({
                            id: doc.id.toString(),
                            name: doc.title,
                            no: doc.no,
                            responsibleFullName: doc.responsibleFullName,
                            createDate: doc.createDate,
                            processId: parseInt(processId),
                            status: doc.status,
                            type: 'URS',
                        })
                    }
                }
            }
        })
    }
})

export const {
    selectAll: selectAllProjectProcesses,
    selectById: selectProjectProcessById,
    selectIds: selectProjectProcessIds,
} = projectProcessAdapter.getSelectors()

export default projectProcessSlice.reducer
